import { styled } from '@mui/material/styles'

export const Segment = styled('section')({
  width: '100%',
  padding: '6px 0px',

  '.MuiCollapse-wrapper': {
    wordBreak: 'break-all',
  },
})

export const ActionWrapper = styled('div')({
  width: '50px',
  display: 'flex',
  justifyContent: 'space-between',
})
